import React from 'react'
import { Box } from '@mui/material'
import InsertChart from '@mui/icons-material/InsertChart'
import { TAB_ENDPOINTS } from '../helpers/reportTabs'
import { downloadUserReportCsv } from '../helpers/downloadUserReportCsv'
import DownloadActionButton from '../../../components/action_button/DownloadActionButton'
import DownloadSplitActionButton from '../../../components/action_button/DownloadSplitActionButton'

const ReportDownloadDropdown = ({
  activeTab,
  startDate,
  endDate,
  searchQuery,
  hasPendingSettlementQuery = ''
}) => {
  const handleDownload = async (typeOverride = null) => {
    const type = typeOverride || TAB_ENDPOINTS[activeTab]
    const filenameLabelOverride =
      type === 'charges_activity' ? 'Actividades' : undefined

    await downloadUserReportCsv({
      csvType: type,
      startDate,
      endDate,
      searchQuery,
      activeTabKey: activeTab,
      filenameLabelOverride,
      hasPendingSettlementQuery
    })
  }

  if (activeTab === 'charges') {
    return (
      <Box sx={{ width: { xs: '100%', md: 260 }, maxWidth: '100%', flexShrink: 0 }}>
        <DownloadSplitActionButton
          text="Descargar"
          density="toolbar"
          fullWidth
          onPrimaryClick={() => handleDownload('charges')}
          menuItems={[
            {
              label: 'Reporte de cobros',
              onClick: () => handleDownload('charges'),
              icon: <InsertChart fontSize="small" />
            },
            {
              label: 'Reporte de actividades - Todos los usuarios',
              onClick: () => handleDownload('charges_activity'),
              icon: <InsertChart fontSize="small" />
            }
          ]}
        />
      </Box>
    )
  }

  return (
    <Box sx={{ width: { xs: '100%', md: 260 }, maxWidth: '100%', flexShrink: 0 }}>
      <DownloadActionButton
        text="Descargar"
        density="toolbar"
        fullWidth
        onClick={() => handleDownload()}
      />
    </Box>
  )
}

export default ReportDownloadDropdown
